{
  "DeleteReminder": "删除提醒",
  "EditReminder": "编辑提醒",
  "RemindMe15Min": "15 分钟后提醒我",
  "RemindMe5Min": "5 分钟后提醒我",
  "RemindMe60Min": "1 小时后提醒我",
  "RemindMeTomorrow": "明天提醒我",
  "SetReminder": "提醒时间为: {formattedReminderTime}",
  "Snooze": "再次提醒"
}
